module.exports = __webpack_public_path__ + "static/img/solutionText7.c78a51c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionText7.png
// module id = waz9
// module chunks = 1